export default __webpack_public_path__ + "static/media/call_blue_icon.9c42e065.svg";